var authenticated = false;

export const authCheck = () => {
  const user = localStorage.getItem("user");
  if(user !== null){
    authenticated = true
  }
  return authenticated
}